class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (this.classList.contains('active')) return;
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer_inner') || this.querySelector('.drawer_close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true },
    );

    document.body.classList.add('overflow-hidden');

    // cart-drawer-items is a CartItems subclass that extends createViewEventElement.
    // Its view-event-trigger="manual" skips auto-dispatch on connect; we fire
    // it here when the drawer opens, with context: 'dialog' from the payload attribute.
    this.querySelector('cart-drawer-items')?.dispatchViewEvent();
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

/* CHECKOUT YAMPI — a Yampi só redireciona na página /cart, e com a gaveta
   o cliente nunca passa por lá. Este bloco intercepta o clique antes do
   botão, cancela o submit pro checkout da Shopify e chama a função da
   própria Yampi. Não volte o botão pra type="submit". */
(function () {
  if (window.__roncadorCheckoutYampi) return;
  window.__roncadorCheckoutYampi = true;

  var SELETOR = '#CartDrawer-Checkout';

  function normalizar(b) {
    if (!b || b.dataset.ympNormalizado === '1') return;
    b.dataset.ympNormalizado = '1';
    b.setAttribute('type', 'button');
    b.removeAttribute('name');
    b.removeAttribute('form');
    b.removeAttribute('onclick');
  }
  function normalizarTodos() {
    document.querySelectorAll(SELETOR).forEach(normalizar);
  }

  normalizarTodos();

  var gaveta = document.querySelector('cart-drawer');
  if (gaveta && 'MutationObserver' in window) {
    new MutationObserver(normalizarTodos).observe(gaveta, { childList: true, subtree: true });
  }

  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest(SELETOR);
    if (!b || b.disabled) return;

    e.preventDefault();
    e.stopPropagation();
    normalizar(b);

    if (b.dataset.ympOcupado === '1') return;
    b.dataset.ympOcupado = '1';

    if (typeof showYampiLoader === 'function') { try { showYampiLoader(); } catch (x) {} }

    if (typeof getNewCheckoutURL !== 'function') { window.location.href = '/cart'; return; }

    if (typeof window.rcCheckoutRapido === 'function') window.rcCheckoutRapido();
    else getNewCheckoutURL();
    setTimeout(function () { window.location.href = '/cart'; }, 5000);
  }, true);
})();

;(function () {
  if (window.__roncadorConexoesYampiV1) return;
  window.__roncadorConexoesYampiV1 = true;

  var destinos = [
    { origem: 'https://api.dooki.com.br', anonima: true },
    { origem: 'https://seguro.roncadorcountry.com.br', anonima: false }
  ];
  var ultimaPreparacao = -Infinity;
  var conexoes = [];
  var dnsPreparado = false;
  var aquecendo = false;

  function aquecerApi() {
    if (aquecendo || typeof window.fetch !== 'function') return;
    aquecendo = true;
    try {
      var pedido = window.fetch('https://api.dooki.com.br/v2/public/shopify/status?shop=' + encodeURIComponent(window.location.host), {
        method: 'GET',
        mode: 'cors',
        credentials: 'omit',
        referrerPolicy: 'origin',
        cache: 'reload',
        priority: 'low'
      });
      Promise.resolve(pedido).then(function (resposta) {
        return resposta.arrayBuffer();
      }).then(function () {
        aquecendo = false;
      }, function () {
        aquecendo = false;
      });
    } catch (ignorar) {
      aquecendo = false;
    }
  }

  function preparar() {
    try {
      if (!document.head || document.visibilityState === 'hidden') return;
      var agora = Date.now();
      if (agora - ultimaPreparacao < 10000) return;
      ultimaPreparacao = agora;

      conexoes.forEach(function (link) {
        if (link.parentNode) link.parentNode.removeChild(link);
      });
      conexoes = [];

      destinos.forEach(function (destino) {
        if (!dnsPreparado) {
          var dns = document.createElement('link');
          dns.rel = 'dns-prefetch';
          dns.href = destino.origem;
          document.head.appendChild(dns);
        }
        var link = document.createElement('link');
        link.rel = 'preconnect';
        link.href = destino.origem;
        if (destino.anonima) link.crossOrigin = 'anonymous';
        document.head.appendChild(link);
        conexoes.push(link);
      });
      dnsPreparado = true;
      aquecerApi();
    } catch (ignorar) {}
  }

  function aproximacao(evento) {
    var alvo = evento.target;
    if (alvo && alvo.closest && alvo.closest('#CartDrawer-Checkout, #cart-icon-bubble')) preparar();
  }

  function iniciar() {
    document.addEventListener('pointerover', aproximacao, { passive: true });
    document.addEventListener('pointerdown', aproximacao, { capture: true, passive: true });
    document.addEventListener('focusin', aproximacao, { passive: true });
    var gaveta = document.querySelector('cart-drawer');
    if (!gaveta) return;
    var estavaAberta = false;
    function verificar() {
      var aberta = gaveta.classList.contains('active');
      if (aberta && !estavaAberta) preparar();
      estavaAberta = aberta;
    }
    if ('MutationObserver' in window) {
      new MutationObserver(verificar).observe(gaveta, {
        attributes: true,
        attributeFilter: ['class']
      });
    }
    verificar();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar, { once: true });
  } else {
    iniciar();
  }
})();

/* 29/10 CHECKOUT RAPIDO — faz o mesmo caminho da funcao da Yampi
   (getNewCheckoutURL), so que sem as esperas que nao precisam:
   1) o carrinho ja fica lido quando a gaveta abre, e so e usado se for
      igual ao que o cliente esta vendo (mesmas pecas e quantidades);
   2) sai para a Yampi logo que ela devolve o link, e esvazia o carrinho
      da Shopify em paralelo (keepalive), em vez de esperar.
   O link continua passando pelo ymp_getUrlWithUtms da Yampi (UTMs e _ga).
   Se qualquer passo falhar, chama a funcao original da Yampi. */
;(function () {
  if (window.__rcCheckoutRapido) return;
  window.__rcCheckoutRapido = true;

  var API = 'https://api.dooki.com.br/v2/public/shopify/cart';
  var VALIDADE = 10 * 60 * 1000;
  var cache = null;
  var buscando = null;

  function assinatura(pares) {
    return pares.sort().join(',');
  }
  function assinaturaGaveta() {
    var pares = [];
    document.querySelectorAll('cart-drawer .quantity__input[data-quantity-variant-id]').forEach(function (el) {
      var q = parseInt(el.value, 10);
      if (q > 0) pares.push(el.getAttribute('data-quantity-variant-id') + ':' + q);
    });
    return assinatura(pares);
  }
  function assinaturaCarrinho(c) {
    return assinatura((c && c.items ? c.items : []).map(function (i) { return i.variant_id + ':' + i.quantity; }));
  }

  function buscar(forcar) {
    if (buscando && !forcar) return buscando;
    var este = window.fetch('/cart.json', {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    }).then(function (r) {
      if (!r.ok) throw new Error('cart');
      return r.json();
    }).then(function (c) {
      cache = { cart: c, ass: assinaturaCarrinho(c), quando: Date.now() };
      if (buscando === este) buscando = null;
      return c;
    }, function (e) {
      if (buscando === este) buscando = null;
      throw e;
    });
    buscando = este;
    return este;
  }

  function cacheBom() {
    var a = assinaturaGaveta();
    return cache && a && cache.ass === a && Date.now() - cache.quando < VALIDADE;
  }

  function carrinhoAtual() {
    if (cacheBom()) return Promise.resolve(cache.cart);
    return buscar(false).then(function (c) {
      var a = assinaturaGaveta();
      if (a && assinaturaCarrinho(c) !== a) return buscar(true);
      return c;
    });
  }

  /* 29/10 (teste 0,5 s): com a gaveta aberta, o link do checkout ja e
     pedido a Yampi antes do clique, e a pagina dele e baixada em segundo
     plano so como arquivo (prefetch, NUNCA prerender: nenhum script da
     Yampi roda antes do clique, entao Pixel/GTM/GA4 nao disparam).
     No clique, se o carrinho ainda for o mesmo, vai direto. */
  var PRONTO_VALIDADE = 4 * 60 * 1000;
  var pronto = null;
  var preparando = false;
  var dica = null;

  function criarLink(c) {
    return window.fetch(API, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ shop: window.location.host, cart_payload: c })
    }).then(function (r) {
      if (!r.ok) throw new Error('yampi');
      return r.json();
    }).then(function (resp) {
      var url = resp && resp.checkout_direct_url;
      if (!url) throw new Error('url');
      if (typeof ymp_getUrlWithUtms === 'function') url = ymp_getUrlWithUtms(url);
      return url;
    });
  }

  function baixarAntes(url) {
    try {
      if (localStorage.getItem('rc-sem-prefetch') === '1') return;
    } catch (ignorar) {}
    if (dica && dica.parentNode) dica.parentNode.removeChild(dica);
    if (window.HTMLScriptElement && HTMLScriptElement.supports && HTMLScriptElement.supports('speculationrules')) {
      dica = document.createElement('script');
      dica.type = 'speculationrules';
      dica.textContent = JSON.stringify({ prefetch: [{ source: 'list', urls: [url] }] });
    } else {
      dica = document.createElement('link');
      dica.rel = 'prefetch';
      dica.as = 'document';
      dica.href = url;
    }
    document.head.appendChild(dica);
  }

  function prontoBom() {
    var a = assinaturaGaveta();
    return pronto && a && pronto.ass === a && Date.now() - pronto.quando < PRONTO_VALIDADE;
  }

  function prepararCheckout() {
    if (preparando || prontoBom()) return;
    preparando = true;
    var carrinho;
    carrinhoAtual().then(function (c) {
      carrinho = c;
      return criarLink(c);
    }).then(function (url) {
      var a = assinaturaCarrinho(carrinho);
      if (a !== assinaturaGaveta()) return;
      pronto = { ass: a, url: url, cart: carrinho, quando: Date.now() };
      baixarAntes(url);
    }).catch(function () {}).then(function () {
      preparando = false;
    });
  }

  function atualizarSePreciso() {
    if (typeof window.fetch !== 'function') return;
    var gaveta = document.querySelector('cart-drawer');
    if (!gaveta || !gaveta.classList.contains('active')) return;
    if (!cacheBom()) {
      buscar(true).then(prepararCheckout, function () {});
    } else {
      prepararCheckout();
    }
  }

  function esvaziarShopify(c) {
    var temKit = typeof ymp_cartHasBundles === 'function' && ymp_cartHasBundles(c);
    if (temKit) return;
    try {
      window.fetch('/cart/clear.js', {
        method: 'POST',
        keepalive: true,
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: '{}'
      }).catch(function () {});
    } catch (ignorar) {}
  }

  window.rcCheckoutRapido = function () {
    if (typeof window.fetch !== 'function' || typeof getNewCheckoutURL !== 'function') {
      if (typeof getNewCheckoutURL === 'function') getNewCheckoutURL();
      return;
    }
    if (prontoBom()) {
      esvaziarShopify(pronto.cart);
      window.location.href = pronto.url;
      return;
    }
    var carrinho;
    carrinhoAtual().then(function (c) {
      carrinho = c;
      return window.fetch(API, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ shop: window.location.host, cart_payload: c })
      });
    }).then(function (r) {
      if (!r.ok) throw new Error('yampi');
      return r.json();
    }).then(function (resp) {
      var url = resp && resp.checkout_direct_url;
      if (!url) throw new Error('url');
      if (typeof ymp_getUrlWithUtms === 'function') url = ymp_getUrlWithUtms(url);
      var temKit = typeof ymp_cartHasBundles === 'function' && ymp_cartHasBundles(carrinho);
      if (!temKit) {
        try {
          window.fetch('/cart/clear.js', {
            method: 'POST',
            keepalive: true,
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: '{}'
          }).catch(function () {});
        } catch (ignorar) {}
      }
      window.location.href = url;
    }).catch(function () {
      getNewCheckoutURL();
    });
  };

  function iniciar() {
    var gaveta = document.querySelector('cart-drawer');
    if (!gaveta || !('MutationObserver' in window)) return;
    var espera = null;
    new MutationObserver(function () {
      clearTimeout(espera);
      espera = setTimeout(atualizarSePreciso, 250);
    }).observe(gaveta, { attributes: true, attributeFilter: ['class'], childList: true, subtree: true });
    document.addEventListener('pointerdown', function (e) {
      if (e.target && e.target.closest && e.target.closest('#CartDrawer-Checkout')) atualizarSePreciso();
    }, { capture: true, passive: true });
    atualizarSePreciso();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();
